import {
    Box,
    Tooltip
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AddrCoordToggle from '../common/AddrCoordToggle';
import {
    Section,
    SectionTitle,
    SectionBody,
    InputForm
} from 'features/geocoder/components/common/BasicComponents';

export default function UploadOptionFields({
    showReverse,
    setShowReverse,
    tab,
    setTab,
    encodingOptions,
    encoding,
    onEncodingChange,
    delimiterOptions,
    delimiter,
    onDelimiterChange,
    showDelimiterOption,
    unifiedAddrOptions,
    unifiedAddrField,
    onAddrFieldChange,
    xyFieldOptions,
    xField,
    onXFieldChange,
    yField,
    onYFieldChange,
    geocodingTypeOptions,
    geocodingType,
    onGeocodingTypeChange,
    coordSystemOptions,
    coordSystem,
    onCoordSystemChange,
}) {
    const isForward = tab === 'forward';
    const showDownloadOptions = isForward && unifiedAddrOptions.length > 0;
    const isReverse = tab === 'reverse';

    return (
        <Section sx={{ width: '100%', mb: 0, pb: 0}}>
            <Box
                sx={{ 
                    display: 'flex', 
                    // justifyContent: 'space-between', 
                    alignItems: 'center', 
                    mb: 0.5,
                }}
            >
                <SectionTitle sx={{ mr: 3, }}>
                    지오코딩 설정
                    <Tooltip 
                        title={"데이터 미리보기를 참고하여 설정해 주세요."}
                        placement="right"
                        arrow
                    >
                        <HelpOutlineIcon 
                            fontSize="small" 
                            sx={{ 
                                color: 'primary.main',
                                cursor: 'pointer',
                                ml: 1,
                                mb: 0.1
                            }} 
                        />
                    </Tooltip>
                </SectionTitle>
                <AddrCoordToggle 
                    showReverse={showReverse} 
                    setShowReverse={setShowReverse}
                />
            </Box>
            <SectionBody sx={{
                display: 'flex',
                justifyContent: 'space-between',
            }}>
                <InputForm 
                    label="인코딩 방식" 
                    selectVal={encoding}
                    options={encodingOptions} 
                    menuItemKey="name" 
                    onChange={onEncodingChange}
                    sx={{ minWidth: 120, mb: 0 }}
                />
                <InputForm 
                    label="구분자" 
                    selectVal={delimiter}
                    options={delimiterOptions} 
                    menuItemKey="name" 
                    onChange={onDelimiterChange}
                    sx={{ minWidth: 120, mb: 0 }}
                />
                <InputForm 
                    label="좌표계" 
                    selectVal={coordSystem}
                    options={coordSystemOptions} 
                    menuItemKey="name" 
                    onChange={onCoordSystemChange}
                    sx={{ minWidth: 350, mb: 0 }}
                />
                {showReverse ? (
                    <>
                        <InputForm 
                            label="X 좌표 필드" 
                            selectVal={xField}
                            options={xyFieldOptions} 
                            menuItemKey={(opt) => `${opt.idx}-${opt.value}`}
                            onChange={onXFieldChange}
                            sx={{ minWidth: 140, mb: 0 }}
                        />

                        <InputForm
                            label="Y 좌표 필드" 
                            selectVal={yField}
                            options={xyFieldOptions} 
                            menuItemKey={(opt) => `${opt.idx}-${opt.value}`}
                            onChange={onYFieldChange}
                            sx={{ minWidth: 140, mb: 0 }}
                        />
                        <InputForm
                            label="주소 유형" 
                            selectVal={geocodingType}
                            options={geocodingTypeOptions} 
                            menuItemKey="name" 
                            onChange={onGeocodingTypeChange}
                            sx={{ minWidth: 100, mb: 0 }}
                        />
                    </>
                ) : (
                    <>
                        <InputForm
                            label="주소 필드" 
                            selectVal={unifiedAddrField}
                            options={unifiedAddrOptions} 
                            menuItemKey="idx" 
                            onChange={onAddrFieldChange}
                            sx={{ minWidth: 180, mb: 0 }}
                        />
                        <InputForm
                            label="주소 유형" 
                            selectVal={geocodingType}
                            options={geocodingTypeOptions} 
                            menuItemKey="name" 
                            onChange={onGeocodingTypeChange}
                            sx={{ minWidth: 180, mb: 0 }}
                        />
                    </>
                )}
            </SectionBody>
        </Section>
    );
}
